/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Categoryrequired1Inputs */

const en_categoryrequired1 = /** @type {(inputs: Categoryrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category is required`)
};

const de_categoryrequired1 = /** @type {(inputs: Categoryrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Category is required" |
*
* @param {Categoryrequired1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const categoryrequired1 = /** @type {((inputs?: Categoryrequired1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Categoryrequired1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_categoryrequired1(inputs)
	return de_categoryrequired1(inputs)
});
export { categoryrequired1 as "categoryRequired" }